import { createAction, props } from '@ngrx/store';
import { UnitsV2 } from '@schenck/rotec-components';
import { RotorTypeFormsData } from 'src/utils/interfaces/rotor-type-forms-data.interfaces';
import {
  RotorTypeRequest,
  GridConfig,
  PaginatedTypeData,
  TypeData,
} from 'src/utils/interfaces/rotor-type.interfaces';

/**
 * Save rotor type to the store
 */
export const saveRotorType = createAction(
  '[RotorTypeList] Save rotor type to the store',
  props<{ rotorType: TypeData }>()
);

/**
 * Reset rotor type from the store
 */
export const resetRotorType = createAction('[RotorTypeList] Reset rotor type to the store');

/**
 * Create rotor type to the store
 */
export const createRotorType = createAction(
  '[RotorTypeList] Create rotor type and save it to the backend',
  props<{
    formData: RotorTypeFormsData;
    units: UnitsV2[];
    isEdit: boolean;
    isFinished?: boolean;
    shouldShowLoader?: boolean;
    preventReload?: boolean;
  }>()
);

/**
 * Duplicate rotor type to the store
 */
export const duplicateRotorType = createAction(
  '[RotorTypeList] Duplicate rotor type and save it to the backend',
  props<{
    id: string;
    name: string;
  }>()
);

/**
 * Load available type data from the back end
 */
export const loadTypeData = createAction(
  '[RotorTypeList] Load available type data',
  props<{ filter?: any; page?: string; limit?: string }>()
);

/**
 * Load selected type data from the back end
 */
export const loadSelectedTypeData = createAction(
  '[RotorTypeList] Load selected type data',
  props<{ id: string }>()
);

/**
 * Save available type data to the store
 */
export const saveRightPanelTypeData = createAction(
  '[RotorTypeList] Save type data for right panel',
  props<{ typeData: TypeData }>()
);

/**
 * Save available type data to the store
 */
export const saveTypeData = createAction(
  '[RotorTypeList] Save available type data',
  props<{ typeData: PaginatedTypeData }>()
);

/**
 * Delete selected rotor type from the back end
 */
export const deleteRotorTypes = createAction(
  '[RotorTypeList] Delete selected rotor types',
  props<{ rotorTypes: RotorTypeRequest[] }>()
);

export const saveGridConfig = createAction(
  '[RotorTypeList] Save available grid config to the store',
  props<GridConfig>()
);

export const updateGridConfig = createAction(
  '[RotorTypeList] Update grid config on the BE',
  props<GridConfig>()
);

export const loadGridConfig = createAction('[RotorTypeList] Load available grid config');
